import { Company } from './company.models';
import { ReceiptBook } from './receiptbook.models';

export class PuntoVenta {
  id: number;
  name: string;
  number: number;
  type: string;
  description: string;
  altitude: string;
  street: string;
  postalCode: string;
  apartment: string;
  email: string;
  phone: string;
  province: string;
  electronic: number;
  floor: string;
  locality: string;
  branchId: number;
  receiptBooks?: ReceiptBook[];
}
